import { useState, useEffect } from 'react';
import masterService from '../services/masterService';

const useMaster = (type) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await masterService.getReferenceMasters(type);
        setData(result);
      } catch (err) {
        setError(err.response?.data?.message || err.message || 'Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    if (type) {
      fetchData();
    }
  }, [type]);

  return { data, loading, error };
};

export default useMaster;
